import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            component: () => import('./views/AppTabbar.vue'),
        },
        {
            path: '/terms',
            name: 'terms',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import('./views/legal/Terms.vue'),
        },
        {
            path: '/service',
            name: 'service',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import('./views/Service.vue'),
        },
        {
            path: '/elua',
            name: 'elua',
            component: () => import('./views/legal/elua.vue'),
        },
        {
            path: '/privacy',
            name: 'privacy',
            component: () => import('./views/legal/Privacy.vue'),
        },
        {
            path: '/data/top-up',
            name: 'data',
            component: () => import('./views/data/TopUp.vue')
        }
    ],
    mode: 'history',
});
